import { PROJECT_NAME } from "./config";
import router from "./router/index";
import store from "./store/index";
import { getToken } from "./utils/auth";
import NProgress from "nprogress";
import { Message } from "element-ui";
NProgress.configure({ showSpinner: false });
/**
 * 路由拦截-后期做token拦截
 */
router.beforeEach(async (to, from, next) => {
  // console.log("to", to, "from", from);
  NProgress.start();
  document.title = PROJECT_NAME + (to.meta.title ? "-" + to.meta.title : "");
  // 监听路由改变文档标题
  if (to.path === "/" || to.path === "/home") {
    next();
  } else {
    // 管理端
    if (to.path.indexOf("/staging") === 0) {
      if (getToken()) {
        let roles = to.meta ? to.meta.roles : null,
          userRole = store.getters["user/role"];
        if (!userRole) {
          try {
            await store.dispatch("user/getInfo");
          } catch (error) {
            // console.error(error);
          }
          userRole = store.getters["user/role"];
        }
        if (userRole) {
          if (to.path === "/staging/dashboard") {
            next();
          } else {
            if (roles && !roles.includes(userRole)) {
              // 角色不符返回工作台
              next({ path: "/staging", replace: true });
            } else {
              const audited = store.getters["user/audited"];
              // 未审核
              if (roles && !audited) {
                if (store.getters["user/isEnterprise"]) {
                  Message.warning("请先完成企业认证");
                } else if (store.getters["user/isExpert"]) {
                  Message.warning("请先完成专家认证");
                } else if (store.getters["user/isPersonal"]) {
                  Message.warning("请先完善用户信息");
                }
                if (from.path === "/staging/dashboard" || from.path === "/staging") {
                  return;
                } else {
                  next({ path: "/staging", replace: true });
                }
              } else {
                next();
              }
            }
          }
        } else {
          next({ path: "/login?redirect=" + to.fullPath, replace: true });
        }
      } else {
        Message.warning("请先登录");
        next({ path: "/login?redirect=" + to.fullPath, replace: true });
      }
    } else {
      // 普通页面
      next();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
